import {Button} from '@mui/material';
import React from 'react';

import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {GuidesEnum} from 'presentation/constants';
import {useLocation} from 'react-router-dom';

import {QualificationItem} from '../QualificationItem';
import {StyledContent, StyledDescription} from './styles';
import {QualificationsModalProps} from './types';
import {QUALIFICATIONS} from '../../../constants/qualifications';
import {ONA_QUALIFICATION_CODES} from '../../../constants/constants';

const {qualifications} = translations['pt-br'].privateFlow.guideFlow;
const {close} = translations['pt-br'].commons;

export function QualificationsModal({open, setOpen}: QualificationsModalProps) {
	const {pathname} = useLocation();
	const isServiceNetworkHealth = pathname === GuidesEnum.SERVICE_NETWORK_HEALTH;

	const qualificationDescription = isServiceNetworkHealth
		? qualifications.descriptionHealth
		: qualifications.descriptionOdonto;

	const filteredQualifications = isServiceNetworkHealth
		? QUALIFICATIONS.filter(
				qualification => !ONA_QUALIFICATION_CODES.includes(qualification.code),
			)
		: QUALIFICATIONS;

	return (
		<Modal.Root open={open} onClose={() => setOpen(false)} customMaxWidth={400}>
			<Modal.Header title={qualifications.title} onClose={() => setOpen(false)} />
			<StyledContent>
				<StyledDescription>{qualificationDescription}</StyledDescription>
				{filteredQualifications.map(qualification => (
					<QualificationItem key={qualification.code} qualification={qualification} />
				))}
			</StyledContent>
			<Modal.Footer>
				<Button size="large" fullWidth onClick={() => setOpen(false)}>
					{close}
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
}
